import { graphql, compose } from 'react-apollo'
import { withAuth } from 'authentication/components/WithAuth'
import { OpenApplicationQuery } from './queries'
import { getGPCStatus } from 'shared/utils'

const extractProps = ({ authProps }) => {
  const { data = {} } = authProps
  const { authentication = {} } = data
  const { isAuthenticated = false, email, currentAppLoanNumber = null } = authentication
  return { isAuthenticated, email, currentAppLoanNumber }
}

const withOpenApplication = component => {
  return graphql(OpenApplicationQuery, {
    options: props => {
      const { email, currentAppLoanNumber: loanNumber} = extractProps(props)

      return {
        variables: { email, isGPCEnabled: getGPCStatus(), loanNumber },
      }
    },
    skip: props => {
      const { isAuthenticated, email } = extractProps(props)
      return !isAuthenticated || !email || email === ''
    },
    props: queryProps => ({ queryProps }),
  })(component)
}

export const withAuthPendingApp = component => {
  return compose(
    withAuth,
    withOpenApplication,
  )(component)
}
